export const nodeApiRoutes = {
  calendar: {
    principalsEvents: ({ calendarId, principalId }: { calendarId: string; principalId: string }) =>
      `/calendar/principals/${principalId}/calendars/${calendarId}/events`,
  },
  communities: {
    find: '/communities',
  },
  events: {
    attachments: {
      create: (eventId: string) => `/events/${eventId}/attachments`,
      delete: (eventId: string, attachmentId: string) => `/events/${eventId}/attachments/${attachmentId}`,
    },
    cancel: (id: string) => `/events/${id}/cancel`,
    create: '/events',
    delete: (id: string) => `/events/${id}`,
    detail: (id: string) => `/events/${id}`,
    distributionList: {
      create: (eventId: string) => `/events/${eventId}/distribution-list`,
    },
    enter: (id: string) => `/events/${id}/enter`,
    find: '/events',
    participants: {
      create: (eventId: string) => `/events/${eventId}/participants`,
      delete: (eventId: string) => `/events/${eventId}/participants`,
      feedback: (eventId: string, participantId: string) => `/events/${eventId}/participants/${participantId}/feedback`,
      get: (eventId: string) => `/events/${eventId}/participants`,
      rsvp: (eventId: string) => `/events/${eventId}/participants/rsvp`,
      update: (eventId: string, participantRef: string) => `/events/${eventId}/participants/${participantRef}`,
    },
  },
  invitationTokens: {
    create: '/invitation-tokens',
  },
  medicalGroups: {
    detail: (id: string) => `/medical-groups/${id}`,
    find: '/medical-groups',
  },
  members: {
    getById: (legacyId: string) => `/users?identifiers.rails.hashid=${legacyId}`,
  },
  organizations: {
    find: '/organizations',
  },
  releaseNotes: {
    find: '/release-notes',
  },
  telehealthVisits: {
    createRequest: '/event-requests/telehealth-visit-requests',
  },
  todos: {
    get: '/todos',
  },
  unsubscribe: {
    email: '/email/unsubscribe',
  },
  users: {
    find: '/users',
    profile: '/users/profile',
  },
};
